<template>
  <div>
    <el-form ref="searchForm" :model="searchForm">
      <QS-search maxLine="2" ref="BLM-search">
        <!-- 内容区域-->
        <el-form-item prop="times" label="操作时间（365天内）">
          <el-date-picker
            v-model="searchForm.times"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item prop="operator" label="操作人姓名">
          <el-input v-model="searchForm.operator" v-delete-emoji placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="操作类型" prop="operateType">
          <el-select v-model="searchForm.operateType" filterable clearable placeholder="请选择" @change="opTypeChangeEvent">
            <el-option v-for="item in opTypeAndContent" :label="item.name" :value="item.code" :key="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="操作内容" prop="operateContent">
          <el-select v-model="searchForm.operateContent" filterable clearable placeholder="请选择" :disabled="searchForm.operateType === ''">
            <el-option v-for="item in opContentList" :label="item.name" :value="item.code" :key="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" prop="plateNo">
          <el-select v-model="searchForm.plateNo" filterable remote reserve-keyword placeholder="请输入" :remote-method="query => remotePlateNoList(query)" :loading="optionsLoading">
            <el-option v-for="item in plateNoList" :key="item.id" :label="item.plateNo" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item prop="carId" label="车辆ID">
          <el-input v-interage v-model="searchForm.carId" placeholder="请输入车辆ID" clearable maxlength="18" />
        </el-form-item>
        <el-form-item label="操作平台" prop="operateSystemType">
          <el-select v-model="searchForm.operateSystemType" placeholder="请选择" clearable>
            <el-option v-for="key in Object.keys(OP_PLATFORMS)" :label="OP_PLATFORMS[key]" :value="key" :key="key" />
          </el-select>
        </el-form-item>
        <el-form-item prop="userAccount" label="操作人账号">
          <el-input v-model.trim="searchForm.userAccount" v-delete-emoji placeholder="请输入操作人账号" clearable />
        </el-form-item>

        <!-- 所属部门 -->
        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect v-model="searchForm.deptIdList" :multiple="true" :isAll="false" />
        </el-form-item>

        <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="BLMloading"
              size="small"
              type="primary"
              @click="() => {
                this.paginationData.pageNum = 1
                this.loadData()
              }"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset">重置</el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <QS-common-table
      class="mt16"
      :loading="BLMloading"
      :columns="headData"
      :data="tableData"
      :pagination="paginationData"
      @change="({ pagination }) => {
        this.paginationData.pageNum = pagination.pageNum
        this.paginationData.pageSize = pagination.pageSize
        this.loadData()
      }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { apiOperationType, apiOperationLogList } from '@/api/company'
import SelectOption from '@/store/dict/selectOptionDict'
import moment from 'moment'
import { FuzzySearch } from '@/api/domain/cars'
import { isEmojiCharacter } from '@/utils/validate'

// 操作平台
const OP_PLATFORMS = SelectOption.operateSystemTypeDict
const TIME_FORMAT = 'YYYY-MM-DD'

export default {
  name: 'workLog',
  data() {
    return {
      OP_PLATFORMS,
      BLMloading: false,
      optionsLoading: false,
      plateNoList: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      searchForm: {
        times: [moment().subtract(6, 'days').format(TIME_FORMAT), moment().format(TIME_FORMAT)],
        operator: '',
        carId: '',
        plateNo: '',
        operateSystemType: '',
        userAccount: '',
        operateType: '',
        operateContent: '',
        deptIdList: [],
      },
      opTypeAndContent: [],
      opContentList: [],
      tableData: [],
      headData: [
        {
          name: 'operationTime',
          columnProps: {
            prop: 'operationTime',
            label: '操作时间',
          },
        },
        {
          name: 'operateType',
          columnProps: {
            prop: 'operateType',
            label: '操作类型',
          },
        },
        {
          name: 'operateContent',
          columnProps: {
            prop: 'operateContent',
            label: '操作内容',
          },
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '业务数据所属部门',
          },
        },
        {
          name: 'operateSystemName',
          columnProps: {
            prop: 'operateSystemName',
            label: '操作平台',
          },
        },
        {
          name: 'operateDetails',
          columnProps: {
            prop: 'operateDetails',
            label: '操作详情',
            width: 180,
          },
        },
        {
          name: 'operator',
          columnProps: {
            prop: 'operator',
            label: '操作人姓名',
          },
        },
        {
          name: 'userAccount',
          columnProps: {
            prop: 'userAccount',
            label: '操作人账号',
          },
        },
        {
          name: 'operateDeptName',
          columnProps: {
            prop: 'operateDeptName',
            label: '操作人所属部门',
          },
        },
        {
          name: 'ip',
          columnProps: {
            prop: 'ip',
            label: 'IP',
          },
        },
      ],
      pickerOptions: {
        disabledDate: (date) => {
          // 不允许选择大于365天之前的日期
          return date.getTime() <= parseInt(moment().subtract(365 + 1, 'days').format('x'))
        },
      },
    }
  },
  methods: {
    /* 车辆模糊搜索 */
    async remotePlateNoList(query) {
      if (isEmojiCharacter(query)) return
      if (query.length >= 4) {
        this.optionsLoading = true
        const res = await FuzzySearch({ plateNo: query, state: 2, allVisible: true }).catch(() => {
          this.optionsLoading = false
        })
        const { code, data } = res || {}
        if (code === 1) {
          this.plateNoList = data
        }
        this.optionsLoading = false
      }
    },
    // 操作类型切换
    opTypeChangeEvent(value) {
      this.searchForm.operateContent = ''
      // 查找操作类型所对应的操作内容
      const findOpContent = this.opTypeAndContent.find((item) => item.code === value)
      this.opContentList = findOpContent ? findOpContent.operateContent : []
    },
    getParams() {
      let gmtCreateBegin = ''
      let gmtCreateEnd = ''
      if (this.searchForm.times?.length) {
        gmtCreateBegin = `${this.searchForm.times[0]} 00:00:00`
        gmtCreateEnd = `${this.searchForm.times[1]} 23:59:59`
      }
      return { ...this.searchForm, gmtCreateBegin, gmtCreateEnd }
    },
    async loadData() {
      this.BLMloading = true
      try {
        const { code, data } = await apiOperationLogList({
          ...this.getParams(),
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        this.BLMloading = false
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.tableData = data.items
        }
      } catch (error) {
        this.BLMloading = false
      }
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.paginationData.pageNum = 1
      this.paginationData.pageSize = 10
      this.loadData()
    },
    getOperationType() {
      apiOperationType().then((res) => {
        this.opTypeAndContent = res?.data || []
      })
    },
  },
  created() {
    this.getOperationType()
  },
  mounted() {
    this.loadData()
    this.$refs['BLM-search'].searchMoreClick()
  },
}
</script>

<style lang='scss' scoped>
</style>
